/**
 * Convert an ISO 3166-1 alpha-2 country code to its flag emoji.
 *
 * Each letter is mapped to its corresponding regional-indicator code
 * point (U+1F1E6 'A' .. U+1F1FF 'Z'); a pair of regional indicators is
 * what renderers render as a national flag. No external library or
 * sprite sheet needed — works in every modern browser and OS that
 * ships emoji fonts.
 *
 * Returns an empty string for input that isn't exactly two ASCII letters.
 * (So `flagFor('USA')` and `flagFor(null)` both render as nothing rather
 * than producing a garbled glyph.)
 */
const REGIONAL_INDICATOR_A = 0x1f1e6;

export function flagFor(code: string | null | undefined): string {
  if (!code) return '';
  const trimmed = code.trim().toUpperCase();
  if (trimmed.length !== 2 || !/^[A-Z]{2}$/.test(trimmed)) return '';
  const [a, b] = trimmed;
  return String.fromCodePoint(
    REGIONAL_INDICATOR_A + (a.charCodeAt(0) - 'A'.charCodeAt(0)),
    REGIONAL_INDICATOR_A + (b.charCodeAt(0) - 'A'.charCodeAt(0)),
  );
}
